<template>
  <div id="app" :class="{fullscreen: fullscreen}">
    <navbar v-show="checkAuth()"></navbar>
    <router-view/>
  </div>
</template>

<script>
import auth from "./utils/auth";
import navbar from "./components/Navbar";

export default {
  name: "app",
  components: { navbar },
  created: function() {
    window.addEventListener("keydown", e => {
      if (e.keyCode === 27) {
        this.$store.commit("undoFullscreen");
      }
      if (e.keyCode === 13 && e.ctrlKey) {
        if (this.$store.state.fullscreen) {
          this.$store.commit("undoFullscreen");
        } else {
          this.$store.commit("makeFullscreen");
        }
      }
    });
  },
  destroyed: function() {
    window.removeEventListener("keydown");
  },
  methods: {
    checkAuth() {
      return auth.isAuthenticated();
    }
  },
  computed: {
    fullscreen() {
      return this.$store.state.fullscreen;
    }
  }
};
</script>

<style>
@import "/css/flexboxgrid.min.css";
@import "https://use.fontawesome.com/releases/v5.0.10/css/all.css";
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  overflow-x: hidden;
  background-color: #f7f7f7;
}

#app.fullscreen {
  cursor: none;
}
body {
  margin: 0;
}
</style>

